// Core Icons (cil)
import { cilAccountLogout } from '@coreui/icons/dist/esm/free/cil-account-logout';
import { cilAlignCenter } from '@coreui/icons/dist/esm/free/cil-align-center';
import { cilAlignLeft } from '@coreui/icons/dist/esm/free/cil-align-left';
import { cilAlignRight } from '@coreui/icons/dist/esm/free/cil-align-right';
import { cilApplicationsSettings } from '@coreui/icons/dist/esm/free/cil-applications-settings';
import { cilArrowBottom } from '@coreui/icons/dist/esm/free/cil-arrow-bottom';
import { cilArrowRight } from '@coreui/icons/dist/esm/free/cil-arrow-right';
import { cilArrowTop } from '@coreui/icons/dist/esm/free/cil-arrow-top';
import { cilBasket } from '@coreui/icons/dist/esm/free/cil-basket';
import { cilBell } from '@coreui/icons/dist/esm/free/cil-bell';
import { cilBold } from '@coreui/icons/dist/esm/free/cil-bold';
import { cilBookmark } from '@coreui/icons/dist/esm/free/cil-bookmark';
import { cilCalculator } from '@coreui/icons/dist/esm/free/cil-calculator';
import { cilCalendar } from '@coreui/icons/dist/esm/free/cil-calendar';
import { cilChart } from '@coreui/icons/dist/esm/free/cil-chart';
import { cilChartPie } from '@coreui/icons/dist/esm/free/cil-chart-pie';
import { cilCheck } from '@coreui/icons/dist/esm/free/cil-check';
import { cilChevronLeft } from '@coreui/icons/dist/esm/free/cil-chevron-left';
import { cilChevronRight } from '@coreui/icons/dist/esm/free/cil-chevron-right';
import { cilCloudDownload } from '@coreui/icons/dist/esm/free/cil-cloud-download';
import { cilCloudUpload } from '@coreui/icons/dist/esm/free/cil-cloud-upload';
import { cilCode } from '@coreui/icons/dist/esm/free/cil-code';
import { cilCommentSquare } from '@coreui/icons/dist/esm/free/cil-comment-square';
import { cilContrast } from '@coreui/icons/dist/esm/free/cil-contrast';
import { cilCreditCard } from '@coreui/icons/dist/esm/free/cil-credit-card';
import { cilCursor } from '@coreui/icons/dist/esm/free/cil-cursor';
import { cilDescription } from '@coreui/icons/dist/esm/free/cil-description';
import { cilDollar } from '@coreui/icons/dist/esm/free/cil-dollar';
import { cilDrop } from '@coreui/icons/dist/esm/free/cil-drop';
import { cilEducation } from '@coreui/icons/dist/esm/free/cil-education';
import { cilLowVision } from '@coreui/icons/dist/esm/free/cil-low-vision';
import { cilEnvelopeClosed } from '@coreui/icons/dist/esm/free/cil-envelope-closed';
import { cilEnvelopeOpen } from '@coreui/icons/dist/esm/free/cil-envelope-open';
import { cilFile } from '@coreui/icons/dist/esm/free/cil-file';
import { cilGrid } from '@coreui/icons/dist/esm/free/cil-grid';
import { cilHome } from '@coreui/icons/dist/esm/free/cil-home';
import { cilInbox } from '@coreui/icons/dist/esm/free/cil-inbox';
import { cilIndentDecrease } from '@coreui/icons/dist/esm/free/cil-indent-decrease';
import { cilIndentIncrease } from '@coreui/icons/dist/esm/free/cil-indent-increase';
import { cilImage } from '@coreui/icons/dist/esm/free/cil-image';
import { cilItalic } from '@coreui/icons/dist/esm/free/cil-italic';
import { cilJustifyCenter } from '@coreui/icons/dist/esm/free/cil-justify-center';
import { cilLanguage } from '@coreui/icons/dist/esm/free/cil-language';
import { cilLayers } from '@coreui/icons/dist/esm/free/cil-layers';
import { cilList } from '@coreui/icons/dist/esm/free/cil-list';
import { cilListNumbered } from '@coreui/icons/dist/esm/free/cil-list-numbered';
import { cilLocationPin } from '@coreui/icons/dist/esm/free/cil-location-pin';
import { cilLockLocked } from '@coreui/icons/dist/esm/free/cil-lock-locked';
import { cilLockUnlocked } from '@coreui/icons/dist/esm/free/cil-lock-unlocked';
import { cilMagnifyingGlass } from '@coreui/icons/dist/esm/free/cil-magnifying-glass';
import { cilMap } from '@coreui/icons/dist/esm/free/cil-map';
import { cilMediaPlay } from '@coreui/icons/dist/esm/free/cil-media-play';
import { cilMonitor } from '@coreui/icons/dist/esm/free/cil-monitor';
import { cilMediaRecord } from '@coreui/icons/dist/esm/free/cil-media-record';
import { cilMenu } from '@coreui/icons/dist/esm/free/cil-menu';
import { cilMoon } from '@coreui/icons/dist/esm/free/cil-moon';
import { cilNotes } from '@coreui/icons/dist/esm/free/cil-notes';
import { cilOptions } from '@coreui/icons/dist/esm/free/cil-options';
import { cilPaperclip } from '@coreui/icons/dist/esm/free/cil-paperclip';
import { cilPaperPlane } from '@coreui/icons/dist/esm/free/cil-paper-plane';
import { cilPen } from '@coreui/icons/dist/esm/free/cil-pen';
import { cilPencil } from '@coreui/icons/dist/esm/free/cil-pencil';
import { cilPeople } from '@coreui/icons/dist/esm/free/cil-people';
import { cilPlus } from '@coreui/icons/dist/esm/free/cil-plus';
import { cilPrint } from '@coreui/icons/dist/esm/free/cil-print';
import { cilPuzzle } from '@coreui/icons/dist/esm/free/cil-puzzle';
import { cilReportSlash } from '@coreui/icons/dist/esm/free/cil-report-slash';
import { cilSave } from '@coreui/icons/dist/esm/free/cil-save';
import { cilSettings } from '@coreui/icons/dist/esm/free/cil-settings';
import { cilShare } from '@coreui/icons/dist/esm/free/cil-share';
import { cilShareAll } from '@coreui/icons/dist/esm/free/cil-share-all';
import { cilShareBoxed } from '@coreui/icons/dist/esm/free/cil-share-boxed';
import { cilSpeech } from '@coreui/icons/dist/esm/free/cil-speech';
import { cilSpeedometer } from '@coreui/icons/dist/esm/free/cil-speedometer';
import { cilSpreadsheet } from '@coreui/icons/dist/esm/free/cil-spreadsheet';
import { cilStar } from '@coreui/icons/dist/esm/free/cil-star';
import { cilSun } from '@coreui/icons/dist/esm/free/cil-sun';
import { cilTags } from '@coreui/icons/dist/esm/free/cil-tags';
import { cilTask } from '@coreui/icons/dist/esm/free/cil-task';
import { cilTrash } from '@coreui/icons/dist/esm/free/cil-trash';
import { cilTruck } from '@coreui/icons/dist/esm/free/cil-truck';
import { cilX } from '@coreui/icons/dist/esm/free/cil-x';
import { cilUnderline } from '@coreui/icons/dist/esm/free/cil-underline';
import { cilUser } from '@coreui/icons/dist/esm/free/cil-user';
import { cilUserFemale } from '@coreui/icons/dist/esm/free/cil-user-female';
import { cilUserFollow } from '@coreui/icons/dist/esm/free/cil-user-follow';
import { cilUserUnfollow } from '@coreui/icons/dist/esm/free/cil-user-unfollow';

// Brand Icons (cib)
import { cibCcAmex } from '@coreui/icons/dist/esm/brand/cib-cc-amex';
import { cibCcApplePay } from '@coreui/icons/dist/esm/brand/cib-cc-apple-pay';
import { cibCcMastercard } from '@coreui/icons/dist/esm/brand/cib-cc-mastercard';
import { cibCcPaypal } from '@coreui/icons/dist/esm/brand/cib-cc-paypal';
import { cibCcStripe } from '@coreui/icons/dist/esm/brand/cib-cc-stripe';
import { cibCcVisa } from '@coreui/icons/dist/esm/brand/cib-cc-visa';
import { cibFacebook } from '@coreui/icons/dist/esm/brand/cib-facebook';
import { cibGoogle } from '@coreui/icons/dist/esm/brand/cib-google';
import { cibLinkedin } from '@coreui/icons/dist/esm/brand/cib-linkedin';
import { cibSkype } from '@coreui/icons/dist/esm/brand/cib-skype';
import { cibTwitter } from '@coreui/icons/dist/esm/brand/cib-twitter';

import { signet } from './signet';
import { logo } from './logo';

export const iconSubset = {
  cibCcAmex,
  cibCcApplePay,
  cibCcMastercard,
  cibCcPaypal,
  cibCcStripe,
  cibCcVisa,
  cibFacebook,
  cibGoogle,
  cibLinkedin,
  cibSkype,
  cibTwitter,
  cilAccountLogout,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilChart,
  cilChartPie,
  cilCheck,
  cilChevronLeft,
  cilChevronRight,
  cilCloudDownload,
  cilCloudUpload,
  cilCode,
  cilCommentSquare,
  cilContrast,
  cilCreditCard,
  cilCursor,
  cilDescription,
  cilDollar,
  cilDrop,
  cilEducation,
  cilLowVision,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilFile,
  cilGrid,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilItalic,
  cilJustifyCenter,
  cilImage,
  cilLanguage,
  cilLayers,
  cilList,
  cilListNumbered,
  cilLocationPin,
  cilLockLocked,
  cilLockUnlocked,
  cilMagnifyingGlass,
  cilMap,
  cilMediaPlay,
  cilMonitor,
  cilMediaRecord,
  cilMenu,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPen,
  cilPencil,
  cilPeople,
  cilPlus,
  cilPrint,
  cilPuzzle,
  cilReportSlash,
  cilSave,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilTruck,
  cilX,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  // API-provided aliases
  cilEye: cilLowVision,
  home: cilHome,
  package: cilBasket,
  'message-circle': cilCommentSquare,
  messageCircle: cilCommentSquare,
  shield: cilLockLocked,
  'bar-chart': cilChart,
  barChart: cilChart,
  file: cilFile,
  calendar: cilCalendar,
  'file-text': cilDescription,
  fileText: cilDescription,
  list: cilList,
  layout: cilGrid,
  image: cilImage,
  briefcase: cilCalculator,
  'credit-card': cilCreditCard,
  'dollar-sign': cilDollar,
  settings: cilSettings,
  tag: cilTags,
  box: cilInbox,
  'book-open': cilEducation,
  logo,
  signet
};

export enum IconSubset {
  cibCcAmex = 'cibCcAmex',
  cibCcApplePay = 'cibCcApplePay',
  cibCcMastercard = 'cibCcMastercard',
  cibCcPaypal = 'cibCcPaypal',
  cibCcStripe = 'cibCcStripe',
  cibCcVisa = 'cibCcVisa',
  cibFacebook = 'cibFacebook',
  cibGoogle = 'cibGoogle',
  cibLinkedin = 'cibLinkedin',
  cibSkype = 'cibSkype',
  cibTwitter = 'cibTwitter',
  cilAccountLogout = 'cilAccountLogout',
  cilAlignCenter = 'cilAlignCenter',
  cilAlignLeft = 'cilAlignLeft',
  cilAlignRight = 'cilAlignRight',
  cilApplicationsSettings = 'cilApplicationsSettings',
  cilArrowBottom = 'cilArrowBottom',
  cilArrowRight = 'cilArrowRight',
  cilArrowTop = 'cilArrowTop',
  cilBasket = 'cilBasket',
  cilBell = 'cilBell',
  cilBold = 'cilBold',
  cilBookmark = 'cilBookmark',
  cilCalculator = 'cilCalculator',
  cilCalendar = 'cilCalendar',
  cilChart = 'cilChart',
  cilChartPie = 'cilChartPie',
  cilCheck = 'cilCheck',
  cilChevronLeft = 'cilChevronLeft',
  cilChevronRight = 'cilChevronRight',
  cilCloudDownload = 'cilCloudDownload',
  cilCloudUpload = 'cilCloudUpload',
  cilCode = 'cilCode',
  cilCommentSquare = 'cilCommentSquare',
  cilContrast = 'cilContrast',
  cilCreditCard = 'cilCreditCard',
  cilCursor = 'cilCursor',
  cilDescription = 'cilDescription',
  cilDollar = 'cilDollar',
  cilDrop = 'cilDrop',
  cilEducation = 'cilEducation',
  cilEye = 'cilEye',
  cilLowVision = 'cilLowVision',
  cilEnvelopeClosed = 'cilEnvelopeClosed',
  cilEnvelopeOpen = 'cilEnvelopeOpen',
  cilFile = 'cilFile',
  cilGrid = 'cilGrid',
  cilHome = 'cilHome',
  cilInbox = 'cilInbox',
  cilIndentDecrease = 'cilIndentDecrease',
  cilIndentIncrease = 'cilIndentIncrease',
  cilImage = 'cilImage',
  cilItalic = 'cilItalic',
  cilJustifyCenter = 'cilJustifyCenter',
  cilLanguage = 'cilLanguage',
  cilLayers = 'cilLayers',
  cilList = 'cilList',
  cilListNumbered = 'cilListNumbered',
  cilLocationPin = 'cilLocationPin',
  cilLockLocked = 'cilLockLocked',
  cilLockUnlocked = 'cilLockUnlocked',
  cilMagnifyingGlass = 'cilMagnifyingGlass',
  cilMap = 'cilMap',
  cilMediaPlay = 'cilMediaPlay',
  cilMonitor = 'cilMonitor',
  cilMediaRecord = 'cilMediaRecord',
  cilMenu = 'cilMenu',
  cilMoon = 'cilMoon',
  cilNotes = 'cilNotes',
  cilOptions = 'cilOptions',
  cilPaperclip = 'cilPaperclip',
  cilPaperPlane = 'cilPaperPlane',
  cilPen = 'cilPen',
  cilPencil = 'cilPencil',
  cilPeople = 'cilPeople',
  cilPlus = 'cilPlus',
  cilPrint = 'cilPrint',
  cilPuzzle = 'cilPuzzle',
  cilReportSlash = 'cilReportSlash',
  cilReload = 'cilReload',
  cilSave = 'cilSave',
  cilSettings = 'cilSettings',
  cilShare = 'cilShare',
  cilShareAll = 'cilShareAll',
  cilShareBoxed = 'cilShareBoxed',
  cilSpeech = 'cilSpeech',
  cilSpeedometer = 'cilSpeedometer',
  cilSpreadsheet = 'cilSpreadsheet',
  cilStar = 'cilStar',
  cilSun = 'cilSun',
  cilTags = 'cilTags',
  cilTask = 'cilTask',
  cilTrash = 'cilTrash',
  cilTruck = 'cilTruck',
  cilX = 'cilX',
  cilUnderline = 'cilUnderline',
  cilUser = 'cilUser',
  cilUserFemale = 'cilUserFemale',
  cilUserFollow = 'cilUserFollow',
  cilUserUnfollow = 'cilUserUnfollow',
  package = 'package',
  messageCircle = 'messageCircle',
  shield = 'shield',
  barChart = 'barChart',
  file = 'file',
  calendar = 'calendar',
  fileText = 'fileText',
  list = 'list',
  layout = 'layout',
  image = 'image',
  settings = 'settings',
  tag = 'tag',
  box = 'box',
  logo = 'logo',
  signet = 'signet'
}

